<template>
  <div class="col d-column">
    <h1 class="title pt-2 mb-0" v-text="$ml.get('invoices')+ '!'"></h1>
    <h1 class="title">
      <span v-text="$ml.get('dashPaySubTitle')" class="pb-2"></span>
    </h1>
    <div>
      <b-nav tabs>
        <b-nav-item :active="menuItem === 'bounties'"  @click="$emit('update:menuItem', 'bounties')" >
          Bounties 
        </b-nav-item>
        <b-nav-item v-if="provisions_control && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" 
          :active="menuItem === 'extract'" 
          @click="$emit('update:menuItem', 'extract')">
          {{this.$ml.get("extract")}}s 
        </b-nav-item>
      </b-nav>
    </div>

    <div v-if="menuItem === 'bounties'" class="card mb-4">
      <Bounties />
    </div>

    <div v-if="menuItem === 'extract'" class="mb-4">
      <Extract/>
    </div>

  </div>
</template>

<script>
import Bounties from "./invoice/bounties.vue"
import Extract from "./invoice/extract.vue"
import PlanService from "../../services/plan.service"

export default {
  name: "payment",
  components: {
    Bounties,
    Extract
  },

  props: ['menuItem'],

  data() {
    return { 
      provisions_control: false
    };
  },

  mounted(){
    this.changeProvisionsControl()
  },

  methods: {
    changeProvisionsControl() {
      PlanService.getCurrentPlanByCompany().then((response) => {
        this.provisions_control = response.data?.provisions_control
      });
    },
  },

};
</script>
